import { FormattedMessageWrapper } from 'components/ui/FormattedMessageWrapper'
import { SUPPORT_CONTACT_URL } from 'config'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

export default function Support(): JSX.Element {
  const intl = useIntl()
  return (
    <Container>
      <Title>{intl.formatMessage({ id: 'courseEditor.supportTitle' })}</Title>
      <Paragraph>
        <FormattedMessageWrapper id="courseEditor.supportParagraph" />
      </Paragraph>
      <StyledLink href={SUPPORT_CONTACT_URL} target="_blank">
        {intl.formatMessage({ id: 'strings.contactUs' })}
      </StyledLink>
    </Container>
  )
}

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 50px;
  max-width: 460px;
  padding: 0 20px;
`

const Title = styled.h1`
  color: #032615;
  font-size: 24px;
  font-weight: 700;
  margin-top: 50px;
  text-align: center;
  text-transform: uppercase;
`

const Paragraph = styled.p`
  color: #424a4d;
  text-align: center;
  font-size: 16px;
  line-height: 150%;
`

const StyledLink = styled.a`
  align-items: center;
  background: #0bb163;
  border-radius: 8px;
  color: #fff;
  display: flex;
  height: 53px;
  justify-content: center;
  text-decoration: none;
  text-transform: capitalize;
  width: 242px;
`
